module.exports = __webpack_public_path__ + "media/images/icons/SVG/070-f5ea3307220e91e2538830b31da92645.svg";